export default __webpack_public_path__ + "static/media/joost_s.a2fdc382.jpg";